import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import IPForm from "components/IP/form"
import { getByIdIP, updateIP } from "store/ips/ips-action"
import { ipsAction } from "store/ips/ips-slice"
import Preloader from "components/Common/Loader"

const EditIP = () => {
  document.title = "Edit IP"

  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, ip, error } = useSelector(state => state.ips)

  /*
  - onSubmit: Triggered when the form is submitted for updating the IP
  - values: Contains the form input values
  - Assigns the current 'id' to values
  - Dispatches the updateIP action with the ID, updated values, and navigation callback
  */
  const onSubmit = values => {
    values.id = id
    dispatch(updateIP(id, values, navigate))
  }

  // get IP by ID
  useEffect(() => {
    dispatch(getByIdIP(id))

    return () => {
      dispatch(ipsAction.resetState())
    }
  }, [])

  return (
    <React.Fragment>
      {ip ? (
        <IPForm
          loading={loading}
          ip={ip?.data}
          error={error}
          onSubmit={onSubmit}
          formMode={"Edit"}
        />
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditIP
